import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import all pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Features from './pages/Features';
import Testimonials from './pages/Testimonials';
import Recruitment from './pages/Recruitment';
import Developing from './pages/Developing';
import Ecommerce from './pages/Ecommerce';
import SocialMedia from './pages/SocialMedia';
import ITConsulting from './pages/ITConsulting';
import Team from './pages/Team';
import TAC from './pages/TAC';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NotFound from './pages/NotFound';

import BhiwandiWebDev from './pages/locations/BhiwandiWebDev';
import MumbaiWebDev from './pages/locations/MumbaiWebDev';

import BlogList from './pages/BlogList';
import BlogDetail from './pages/BlogDetail';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/index.html" element={<Home />} />

        {/* Main Nav Links */}
        <Route path="/about" element={<About />} />
        <Route path="/about.html" element={<About />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/contact.html" element={<Contact />} />

        <Route path="/service" element={<Services />} />
        <Route path="/service.html" element={<Services />} />

        {/* Dropdown / Other Pages */}
        <Route path="/project" element={<Projects />} />
        <Route path="/project.html" element={<Projects />} />

        <Route path="/feature" element={<Features />} />
        <Route path="/feature.html" element={<Features />} />

        <Route path="/testimonial" element={<Testimonials />} />
        <Route path="/testimonial.html" element={<Testimonials />} />

        {/* Services / Sub-pages */}
        <Route path="/web-development" element={<Developing />} />
        <Route path="/developing" element={<Developing />} /> {/* canonical fallback */}
        <Route path="/developing.html" element={<Developing />} />

        <Route path="/ecommerce-development" element={<Ecommerce />} />
        <Route path="/ecommerce" element={<Ecommerce />} /> {/* canonical fallback */}
        <Route path="/ecommerce.html" element={<Ecommerce />} />

        {/* Location SEO pages */}
        <Route path="/bhiwandi/web-development" element={<BhiwandiWebDev />} />
        <Route path="/mumbai/web-development" element={<MumbaiWebDev />} />

        {/* Blog System Pages */}
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />

        <Route path="/smedia" element={<SocialMedia />} />
        <Route path="/smedia.html" element={<SocialMedia />} />

        <Route path="/itc" element={<ITConsulting />} />
        <Route path="/itc.html" element={<ITConsulting />} />

        {/* Additional Pages */}
        <Route path="/recruitment" element={<Recruitment />} />
        <Route path="/recruitment.html" element={<Recruitment />} />

        <Route path="/team" element={<Team />} />
        <Route path="/team.html" element={<Team />} />

        <Route path="/tac" element={<TAC />} />
        <Route path="/tac.html" element={<TAC />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* 404 Catch-All */}
        <Route path="/404" element={<NotFound />} />
        <Route path="/404.html" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
